import { axiosClientv1 } from "./apiClient";
import { ApiResponse } from "../Types";

export const GetBarcodeTemplates = async (): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get("/barcode-templates");
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to load barcode templates.",
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const GetBarcodeTemplateDetail = async (
  id: string,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get("/barcode-templates/detail", {
      params: { id },
    });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message ||
        "Failed to load barcode template details.",
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const CreateBarcodeTemplate = async (data: {
  name: string;
  width: number;
  height: number;
  elements: string;
  is_default?: boolean;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(
      "/barcode-templates/create",
      data,
    );
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to create barcode template.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

export const UpdateBarcodeTemplate = async (data: {
  id: string;
  name: string;
  width: number;
  height: number;
  elements: string;
  is_default?: boolean;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(
      "/barcode-templates/update",
      data,
    );
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to update barcode template.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

export const DeleteBarcodeTemplate = async (
  id: string,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post("/barcode-templates/delete", {
      id,
    });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to delete barcode template.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

export const SetDefaultBarcodeTemplate = async (
  id: string,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(
      "/barcode-templates/set-default",
      { id },
    );
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message ||
        "Failed to set default barcode template.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};
